import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/Layout/MainLayout.vue'),
    children:[
      {
        path:'/',
        name:'home',
        component: () => import('../views/Home.vue'),
        meta:{
          nav:'home'
        }
      },
      {
        path:'Subplatform',
        component: () => import('../views/SubPlatform.vue'),
        children:[
          {
            path:'',
            component: () => import('../components/SubPlatform/SubPlatformLayout.vue'),
            children:[{
              path:'SubPlatformList',
              name:'subPlatformlist',
              component: () => import('../components/SubPlatform/SubPlatformListCom.vue'),
              meta:{
                nav:'subplatform'
              }
            }]
          },
          
        ],
        meta:{
          nav:'subplatform'
        }
      },
      {
        path:'Subplatform/:id',
        name:'subplatformdetail',
        component: () => import('../components/SubPlatform/SubPlatformDetail.vue'),
        meta:{
          nav:'subplatform'
        }
      },
      {
        path:'Foundation',
        component: () => import('../views/Layout/FoundationLayout.vue'),
        children:[{
          path:'material',
          name:'material',
          component: () => import('../views/Foundation/Material.vue'),
          meta:{
            nav:'Foundation',
            sub_nav:'material'
          }
        },
        {
          path:'demand',
          name:'demand',
          component: () => import('../views/Foundation/Demand.vue'),
          meta:{
            nav:'Foundation',
            sub_nav:'demand'
          }
        },
        {
          path:'supply',
          name:'supply',
          component: () => import('../views/Foundation/Supply.vue'),
          meta:{
            nav:'Foundation',
            sub_nav:'supply'
          }
        },
      ],
      },
      {
        path:'DemandDetail/:id',
        name:'demanddetail',
        component: () => import('../components/Demand/DemandDetail.vue'),
        meta:{
          nav:'Foundation'
        }
      },
      {
        path:'SupplierDetail/:id',
        name:'supplierdetail',
        component: () => import('../components/Demand/SupplierDetail.vue'),
        meta:{
          nav:'Foundation'
        }
      },
      {
        path:'Overview',
        component: () => import('../views/Overview.vue'),
        children:[
          {
            path:'',
            component: () => import('../components/Overview/OverviewLayout.vue'),
            children:[{
              path:'unionnewslist',
              name:'unionnewslist',
              component: () => import('../components/Overview/UnionNewsListCom.vue'),
              meta:{
                nav:'overview'
              }
            }]
          },
          
        ],
        meta:{
          nav:'overview'
        }
      },
      {
        path:'UnionDetail/:id',
        name:'uniondetail',
        component: () => import('../components/Overview/UnionNewsDetailCom.vue'),
        meta:{
          nav:'overview'
        }
      },
      {
        path:'Activity',
        component: () => import('../views/Layout/ActivityLayout.vue'),
        children:[{
          path:'Meeting',
          name:'meeting',
          component: () => import('../views/Activity/Meeting.vue'),
          meta:{
            nav:'activity',
            sub_nav:'meeting'
          }
        },
        {
          path:'Exhibition',
          name:'exhibition',
          component: () => import('../views/Activity/Exhibition.vue'),
          meta:{
            nav:'activity',
            sub_nav:'exhibition'
          }
        },
        {
          path:'Service',
          name:'service',
          component: () => import('../views/Activity/ActivityService.vue'),
          meta:{
            nav:'activity',
            sub_nav:'service'
          }
        },
      ],
      },
      {
        path:'IntlActivityDetail/:id',
        name:'intlactivitydetail',
        component: () => import('../components/Activity/IntlActivityDetail.vue'),
        meta:{
          nav:'activity'
        }
      },
      {
        path:'ArvoActivityDetail/:id',
        name:'arvoActivitydetail',
        component: () => import('../components/Activity/ArvoActivityDetail.vue'),
        meta:{
          nav:'activity'
        }
      },
      {
        path:'Popsci',
        component: () => import('../views/Layout/PopsciLayout.vue'),
        children:[{
          path:'PopsciActivity',
          name:'popsciactivity',
          component: () => import('../views/Popsci/Activity.vue'),
          meta:{
            nav:'popsci',
            sub_nav:'activity'
          }
        },
        {
          path:'PopsciVideo',
          name:'popscivideo',
          component: () => import('../views/Popsci/Video.vue'),
          meta:{
            nav:'popsci',
            sub_nav:'video'
          }
        }
      ],
      },
      {
        path:'PopsciActivityDetail/:id',
        name:'popsciactivitydetail',
        component: () => import('../components/Popsci/PopsciActivityDetail.vue'),
        meta:{
          nav:'popsci'
        }
      },
      {
        path:'PopsciDetail/:id',
        name:'popscidetail',
        component: () => import('../components/Popsci/PopsciDetail.vue'),
        meta:{
          nav:'popsci'
        }
      },
      {
        path:'VideoDetail/:id/:video_index',
        name:'videodetail',
        component: () => import('../components/Popsci/VideoDetail.vue'),
        meta:{
          nav:'popsci'
        }
      },
      {
        path:'NewsList/:id?',
        name:'newslist',
        component: () => import('../components/News/NewsList.vue'),
      },
      {
        path:'NewsDetail/:id',
        name:'newsdetail',
        component: () => import('../components/News/NewsDetail.vue'),
      },
    ]
  }
]


const router = new VueRouter({
  mode:'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition
      }
      return {
          x: 0,
          y: 0
      }
  }
})

export default router
